<script>
  import { Toast } from 'flowbite-svelte';
  import {
    CheckCircleSolid,
    InfoCircleSolid,
    ExclamationCircleSolid,
  } from 'flowbite-svelte-icons';
  import { TOAST_ERROR, TOAST_SUCCESS, TOAST_INFO } from '../constants';
  import { dismissToast, toasts } from '../store';

  function getColor(type) {
    switch (type) {
      case TOAST_SUCCESS:
        return 'green';
      case TOAST_ERROR:
        return 'red';
      default:
        return 'blue';
    }
  }
</script>

{#if $toasts.length}
  <section
    class="fixed left-0 right-0 top-0 z-50 mt-8 flex w-full flex-col items-center justify-center"
  >
    {#each $toasts as toast (toast.id)}
      <Toast
        on:close={() => dismissToast(toast.id)}
        color={getColor(toast.type)}
        class="mb-2 drop-shadow-2xl"
        ><svelte:fragment slot="icon">
          {#if toast.type === TOAST_SUCCESS}
            <CheckCircleSolid class="h-5 w-5" />
            <span class="sr-only">Success icon</span>
          {:else if toast.type === TOAST_ERROR}
            <ExclamationCircleSolid class="h-5 w-5" />
            <span class="sr-only">Warning icon</span>
          {:else if toast.type === TOAST_INFO}
            <InfoCircleSolid class="h-5 w-5" />
            <span class="sr-only">Info icon</span>
          {:else}
            <InfoCircleSolid class="h-5 w-5" />
            <span class="sr-only">Info icon</span>
          {/if}
        </svelte:fragment>
        {toast.message}</Toast
      >
    {/each}
  </section>
{/if}
